export const NavigationBar = ({
  stepCount,
  currentStep,
}: {
  stepCount: number;
  currentStep: number;
}) => (
  <div className="my-4 flex justify-between gap-x-4 p-4">
    {Array.from({ length: stepCount }).map((_, index) => (
      <div
        key={index}
        className={`h-1 w-full rounded-full ${
          index === currentStep ? 'bg-brand-secondary' : 'bg-zinc-200'
        }`}
      />
    ))}
  </div>
);
